import React, { FunctionComponent } from 'react';
import type { PopoverMenuProps } from './types';
import usePopoverMenu from './usePopoverMenu';
import PopoverMenuItem, { type PopoverMenuItemProps } from './PopoverMenuItem';
import type { NavigationLinkProps } from '~/components/NavigationLink';
import type { StringIndexedObject } from '~/types';

const PopoverMenu: FunctionComponent<PopoverMenuProps> = function ({
  items,
  className = '',
  onClose,
  size,
  header,
  content,
  selectedColorVariant = 'default',
  notice: Notice,
}) {
  const { linkComponent: LinkComponent, classNames } =
    usePopoverMenu(className);

  const LinkComponentTag =
    LinkComponent as FunctionComponent<NavigationLinkProps>;

  return (
    <div className={classNames.container}>
      {Notice && <Notice />}
      <div className={classNames.paddingContainer}>
        {header && (
          <>
            {header}
            <div className={classNames.seperatorWrapper}>
              <div className={classNames.seperator} />
            </div>
          </>
        )}
        <div onClick={onClose} className={classNames.content}>
          {content ||
            items.map(
              ({ icon, name, arrow, selected, seperator, ...linkProps }) => {
                const popoverMenuItemProps: PopoverMenuItemProps = {
                  icon,
                  name,
                  size,
                  arrow,
                  selected,
                  selectedColorVariant,
                };

                return (
                  <React.Fragment key={name}>
                    {seperator ? (
                      <div className={classNames.seperatorWrapper}>
                        <div className={classNames.seperator} />
                      </div>
                    ) : (
                      <>
                        {linkProps.onClick ? (
                          <div
                            key={name}
                            {...linkProps}
                            className={classNames.link}
                          >
                            <PopoverMenuItem {...popoverMenuItemProps} />
                          </div>
                        ) : (
                          <LinkComponentTag
                            key={name}
                            {...(linkProps as StringIndexedObject<string>)}
                            className={classNames.link}
                          >
                            <PopoverMenuItem {...popoverMenuItemProps} />
                          </LinkComponentTag>
                        )}
                      </>
                    )}
                  </React.Fragment>
                );
              },
            )}
        </div>
      </div>
    </div>
  );
};

export default PopoverMenu;
